import React, { useState, useEffect } from 'react';
import styles from './LoginHistory.module.css';
import { format } from 'date-fns';
import { authService } from '../../services/api';

const LoginHistory = ({ isOpen, onClose }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const email = user.email;

  useEffect(() => {
    if (isOpen) {
      fetchLoginHistory();
    }
  }, [isOpen]);

  const fetchLoginHistory = async () => {
    try {
      
      const response = await authService.getLoginHistory({
        email
      });
      if (response.data.status === 'success') {
        setHistory(response.data.history);
      } else {
        throw new Error(response.data.message || 'Failed to fetch login history');
      }
    } catch (err) {
      console.error('Error fetching login history:', err);
      setError('Failed to load login history');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2>Login History</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className={styles.modalContent}>
          {loading ? (
            <div className={styles.loading}>
              <div className={styles.spinner}></div>
              <span>Loading login history...</span>
            </div>
          ) : error ? (
            <div className={styles.error}>
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          ) : (
            <div className={styles.sessionList}>
              {history.map((entry) => (
                <div key={entry.id} className={`${styles.sessionItem} ${entry.status === 'failed' ? styles.failedLogin : ''}`}>
                  <div className={styles.sessionHeader}>
                    <div className={styles.deviceInfo}>
                      <i className={`fas fa-${entry.device_info.toLowerCase().includes('mobile') ? 'mobile-alt' : 'desktop'}`}></i>
                      <span>{entry.browser}</span>
                    </div>
                    <span className={entry.status === 'success' ? styles.successStatus : styles.failedStatus}>
                      <i className={`fas fa-${entry.status === 'success' ? 'check-circle' : 'exclamation-circle'}`}></i>
                      {entry.status === 'success' ? 'Successful Login' : 'Failed Attempt'}
                    </span>
                  </div>
                  
                  <div className={styles.sessionDetails}>
                    <div className={styles.locationInfo}>
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{`${entry.location_city}, ${entry.location_region}, ${entry.location_country}`}</span>
                    </div>
                    <div className={styles.timeInfo}>
                      <div>
                        <i className="fas fa-calendar"></i>
                        <span>Login time: {format(new Date(entry.login_time), 'MMM dd, yyyy HH:mm')}</span>
                      </div>
                    </div>
                    <div className={styles.ipInfo}>
                      <i className="fas fa-network-wired"></i>
                      <span>IP: {entry.ip_address}</span>
                    </div>
                    {entry.status === 'failed' && entry.failure_reason && (
                      <div className={styles.failureReason}>
                        <i className="fas fa-exclamation-triangle"></i>
                        <span>Reason: {entry.failure_reason}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginHistory; 